import paginationView from './paginationComponent.html';
import './paginationComponent.css';

export function paginationComponent() {
	return {
		bindings: {
			page: '<',
			total: '<',
			go: '&',
		},
		controllerAs: 'vm',
		controller: paginationComponentCtrl,
		template: paginationView,
	};
}

export class paginationComponentCtrl {
	click(pageNumber) {
		if (typeof pageNumber == 'number') {
			this.go({ $page: pageNumber });
		}
	}

	$onChanges() {
		if (typeof this.page == 'number' && typeof this.total == 'number') {
			this.buildLinks();
		}
	}

	buildLinks() {
		this.labels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
		if (this.total <= 10) {
			this.labels = this.labels.slice(0, this.total);
		} else if (this.page <= 5) {
			this.labels[8] = '...';
			this.labels[9] = this.total;
		} else if (this.page + 5 > this.total) {
			this.labels = [
				1,
				'...',
				this.total - 7,
				this.total - 6,
				this.total - 5,
				this.total - 4,
				this.total - 3,
				this.total - 2,
				this.total - 1,
				this.total,
			];
		} else {
			this.labels = [1, '...', this.page - 2, this.page - 1, this.page, this.page + 1, this.page + 2, '...', this.total];
		}
		this.prev = this.page == 1 ? null : this.page - 1;
		this.next = this.page == this.total ? null : this.page + 1;
	}
}
